<template>
  <p class="text-md text-slate-600 dark:text-zinc-300">
    Please
    <a
      href="#"
      @click.stop.prevent="showSignUpModal()"
      data-testid="viewer-add-comment-modal-sign-up"
      class="text-blue-600 underline rounded-sm hover:text-blue-400 focus-visible:ring focus-visible:ring-blue-500/50 focus-visible:bg-blue-500/10 focus:outline-none"
      >sign up</a
    >
    or
    <a
      href="#"
      @click.stop.prevent="showSignInModal()"
      data-testid="viewer-add-comment-modal-sign-in"
      class="text-blue-600 underline rounded-sm hover:text-blue-400 focus-visible:ring focus-visible:ring-blue-500/50 focus-visible:bg-blue-500/10 focus:outline-none"
      >sign in</a
    >
    if you want to edit or delete your comments.
  </p>
</template>
<script lang="ts" setup>
import { useAuthModals } from '@/composables/useAuthModals';

const { showSignInModal, showSignUpModal } = useAuthModals();
</script>
